<form
  class="form-b4a"
  *ngIf="form && (paymentResponseMessage || paymentResponseMessage === null)"
  [formGroup]="form"
  (submit)="submit()"
>
  <span class="p-float-label small-info">
    <input id="code" type="text" pInputText formControlName="code" />
    <label for="code">Código do erro no gateway*</label>
    <small
      class="error"
      *ngIf="
        form.controls['code'].errors &&
        form.controls['code'].errors['maxlength']
      "
    >
      Máximo de
      {{ form.controls['code'].errors['maxlength']['requiredLength'] }}
      caracteres
    </small>
    <small
      class="error"
      *ngIf="
        form.controls['code'].errors &&
        form.controls['code'].errors['minlength']
      "
    >
      Mínimo de
      {{ form.controls['code'].errors['minlength']['requiredLength'] }}
      caracteres
    </small>
    <small *ngIf="!paymentResponseMessage">Ex: 00001</small>
    <small *ngIf="paymentResponseMessage"
      >*Não é possível alterar o código de erro</small
    >
  </span>
  <span class="p-float-label small-info">
    <p-dropdown
      formControlName="paymentResponseMessageTypeId"
      [options]="paymentResponseTypes"
      optionLabel="typeContent"
      optionValue="paymentResponseMessageTypeId"
      appendTo="body"
    >
      <ng-template pTemplate="item" let-option>
        <div class="dropdown-item">
          {{ option.typeContent }}
          <img [src]="option.iconURL" [alt]="option.title" />
        </div>
      </ng-template>
      <ng-template pTemplate="selectedItem">
        <div class="dropdown-item">
          {{ selectedResponseType?.typeContent }}
          <img
            [src]="selectedResponseType?.iconURL"
            [alt]="selectedResponseType?.title"
          />
        </div>
      </ng-template>
    </p-dropdown>
    <label for="paymentResponseMessageType">Tipo de erro*</label>
  </span>
  <span class="p-float-label small-info">
    <p-dropdown
      formControlName="gatewayId"
      [options]="gateways"
      optionLabel="gatewayName"
      optionValue="gatewayId"
      appendTo="body"
    />
    <label for="gateway">Gateway*</label>
    <small *ngIf="paymentResponseMessage"
      >*Não é possível alterar o gateway</small
    >
  </span>
  <div class="buttons">
    <p-button
      *ngIf="permission"
      [disabled]="!form.valid"
      severity="primary"
      label="Salvar"
      type="submit"
    />
  </div>
</form>
